import styled, { css } from 'styled-components'
import { Spinner } from '@mote/ui'
import { Control, PlayPauseButton } from '../../shared/components'

const backgroundColor = '#0000EE'
const buttonSize = 24
const buttonSpacing = css({ marginRight: 11 })

function getColors(reverse) {
  const colors = [backgroundColor, '#fff']
  if (reverse) {
    colors.reverse()
  }
  return {
    backgroundColor: colors[0],
    color: colors[1]
  }
}

export const StyledPlayToteButton = styled(PlayPauseButton).attrs({
  size: buttonSize
})(buttonSpacing, {
  ...getColors(),
  '&:hover, &:focus': {
    ...getColors(true)
  }
})

export const StyledSpinner = styled(Spinner).attrs({
  color: backgroundColor,
  radius: buttonSize
})(buttonSpacing)

export const ErrorControl = styled(Control).attrs({
  tooltipProps: { disabled: true },
  size: buttonSize
})(buttonSpacing)
